import { Loader } from 'components/shared/Loader';
import { useTranslation } from 'react-i18next';

export const StuffedKeywordsBox = ({
  keywordStuffingLoading,
  stuffedKeywords,
  initialStuffedKeywords,
}) => {
  const { t } = useTranslation();

  return (
    <div className="box-wrapper box-list-text">
      <div className="header-title mb-0">{t('Mots clés Bourrées')} :</div>
      <br />
      <div className="box-list-text box-motcle">
        {keywordStuffingLoading && <Loader />}

        {!keywordStuffingLoading && !!stuffedKeywords?.length && (
          <div>
            <b>{t('Dans le texte actuel')} : </b>
            <ul>
              {stuffedKeywords.map((item) => {
                const tfPercentage = item['tfPercentage'] * 100;
                let colorClass = 'keywordStuffedYellow';

                if (tfPercentage > 2) {
                  colorClass = 'keywordStuffedRed';
                }

                if (tfPercentage > 1.5 && tfPercentage <= 2) {
                  colorClass = 'keywordStuffedOrange';
                }

                return (
                  <li key={item['word']} className={colorClass}>
                    <span> {item['word']} </span> (
                    <span>{tfPercentage.toFixed(2)}% </span>)
                  </li>
                );
              })}
            </ul>
          </div>
        )}

        {!keywordStuffingLoading && !!initialStuffedKeywords?.length && (
          <div>
            <b>{t('Dans le texte initial')} : </b>
            <ul>
              {initialStuffedKeywords.map((item) => {
                const tfPercentage = item['tfPercentage'] * 100;
                let colorClass;

                if (tfPercentage > 2) {
                  colorClass = 'keywordStuffedPurple';
                }
                return (
                  <li key={item['word']} className={colorClass}>
                    <span> {item['word']} </span> (
                    <span>{tfPercentage.toFixed(2)}% </span>)
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};
